import { FsRoute, StaticView } from './shared/model'
import PtHome from './views/fs-pt-home-view/fs-pt-home-view'
import PtKPIsView from './views/fs-pt-kpis-view/fs-pt-kpis-view'
import PtUploadView from './views/fs-upload-view/pt-upload-view'
import PtInteractiveView from './views/fs-pt-interactive-view/fs-pt-interactive-view'
import PtDataUploadStepsView from './views/fs-pt-datauploadsteps/fs-pt-datauploadsteps'

const slug = process.env.REACT_APP_SLUG

const TestingPtRoutes: FsRoute[] = []

const PtRoutes: FsRoute[] = [
  {
    path: '/pt/home',
    name: StaticView.PTHOME,
    component: <PtHome />
  },
  {
    path: '/pt/kpis',
    name: StaticView.PTKPIS,
    component: <PtKPIsView />,
  },
  {
    path: '/pt/upload-files',
    name: StaticView.UPLOAD,
    component: <PtUploadView />,
  },
  {
    path: '/pt/assistance',
    name: StaticView.PTASSISSTANCE,
    component: <PtInteractiveView />,
  },
  {
    path: '/pt/data-upload-steps',
    name: StaticView.PTDATAUPLOADSTEPS,
    component: <PtDataUploadStepsView />,
  },
]

export default slug === 'stagingaws' ? [...PtRoutes, ...TestingPtRoutes] : PtRoutes
